import { createClient, SupabaseClient } from '@supabase/supabase-js';
import { environment } from '../../environments/environment';

/** True when the data client and the auth client point at the same project —
 *  then a single GoTrue client is shared to avoid two clients competing for the
 *  same storage key / lock. */
export function isSameSupabaseProject(
  dataUrl: string, dataKey: string, authUrl: string, authKey: string,
): boolean {
  return dataUrl === authUrl && dataKey === authKey;
}

// Azure OAuth client — owns browser session persistence for the OAuth redirect.
const authClient: SupabaseClient = createClient(
  environment.authSupabaseUrl,
  environment.authAnonKey,
  { auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true } },
);

const sameProject = isSameSupabaseProject(
  environment.supabaseUrl, environment.supabaseAnonKey,
  environment.authSupabaseUrl, environment.authAnonKey,
);

// Data + password-auth client. In prod it IS the auth client (same project) so
// the OAuth hash is parsed once. In dev it's the self-hosted project and must
// NOT try to parse the cloud OAuth redirect hash.
export const supabase: SupabaseClient = sameProject
  ? authClient
  : createClient(environment.supabaseUrl, environment.supabaseAnonKey, {
      auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: false },
    });

export const supabaseAuth: SupabaseClient = authClient;
